/**
 * PAYMENT BADGE CELL
 * Cellule table pour la colonne "Statut BPI" dans ProspectsListPage
 * Wrapper autour de StatusBadgeCell avec les labels/couleurs de payment.ts
 */

import { StatusBadgeCell } from '../tables/cells/StatusBadgeCell';
import type { PaymentStatus } from '../../types/payment';
import { PAYMENT_STATUS_LABELS, PAYMENT_STATUS_COLORS } from '../../types/payment';

interface PaymentBadgeCellProps {
  status: PaymentStatus | null;
}

export function PaymentBadgeCell({ status }: PaymentBadgeCellProps) {
  if (!status) {
    return <span className="text-sm text-zinc-400">—</span>;
  }

  return (
    <StatusBadgeCell
      status={status}
      labels={PAYMENT_STATUS_LABELS}
      colors={PAYMENT_STATUS_COLORS}
    />
  );
}
